// @flow

/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

import React from 'react';

import styles from './simpleHeader.scss';
import RivigoIcon from '../../../assets/images/rivigo-logo.png';

const SimpleHeader = () => (
  <div className={styles.header}>
    <img
      role="button"
      className={styles.svg}
      src={RivigoIcon}
      alt="Rivigo"
      onClick={() => {
        window.open('https://rivigo.com');
      }}
    />
  </div>
);

export default SimpleHeader;
